import  InboundTransport  from "./InboundTransport";

export default InboundTransport;